import React from 'react';

const SubmitInput = ({value = 'Submit'}) => (
    <input className="btn btn-secondary mr-3" type="submit" value={value} />
);

export default SubmitInput;